<template>
    <Teleport to="body">
        <Modal
            :show="show"
            @close="$emit('close')"
        >
            <template #body>
                <p>Are you sure you want to save these changes?</p>
            </template>
            <template #footer>
                <al-button
                    variant="secondary"
                    @click="$emit('close')"
                >
                    Cancel
                </al-button>
                <al-button
                    variant="primary"
                    @click="$emit('confirm')"
                >
                    Yes, save changes
                </al-button>
            </template>
        </Modal>
    </Teleport>
</template>

<script setup lang="ts">
import Modal from '@agyletime/vue-3-common/src/components/Modal/TeleportModal.vue';

interface Props {
    show: boolean;
}

defineProps<Props>();
defineEmits<{
    close: [];
    confirm: [];
}>();
</script>